module.exports = __webpack_public_path__ + "img/reputational.2260329b.png";